var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"az-body",attrs:{"id":"app","name":"app"}},[_c('nprogress-container'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }